import api from '../utils/api'

/**
 * 回访提醒配置相关API
 */

// 获取回访提醒配置列表
export const getRevisitReminderConfigs = (businessId) => {
  return api.get(`/api/business_B/${businessId}/revisit-reminder-configs`)
}

// 获取单一回访提醒配置
export const getRevisitReminderConfig = (businessId, configId) => {
  return api.get(
    `/api/business_B/${businessId}/revisit-reminder-configs/${configId}`
  )
}

// 上傳回訪提醒附圖
// 回傳 { imageUrl, imagePreviewUrl }（皆為 B2 相對路徑），後端已統一轉成 LINE 吃得下的 JPEG
export const uploadRevisitReminderImage = (businessId, file) => {
  const formData = new FormData()
  formData.append('image', file)
  return api.post(
    `/api/business_B/${businessId}/revisit-reminder-configs/upload-image`,
    formData
  )
}

// 创建回访提醒配置
export const createRevisitReminderConfig = (businessId, data) => {
  return api.post(
    `/api/business_B/${businessId}/revisit-reminder-configs`,
    data
  )
}

// 更新回访提醒配置
export const updateRevisitReminderConfig = (businessId, configId, data) => {
  return api.put(
    `/api/business_B/${businessId}/revisit-reminder-configs/${configId}`,
    data
  )
}

// 删除回访提醒配置
export const deleteRevisitReminderConfig = (businessId, configId) => {
  return api.delete(
    `/api/business_B/${businessId}/revisit-reminder-configs/${configId}`
  )
}

// 预览符合条件的客户（不发送）
export const previewRevisitReminderRecipients = (businessId, configId) => {
  return api.get(
    `/api/business_B/${businessId}/revisit-reminder-configs/${configId}/preview`
  )
}

// 发送回访提醒
export const sendRevisitReminder = (businessId, configId, dryRun = false) => {
  return api.post(
    `/api/business_B/${businessId}/revisit-reminder-configs/${configId}/send`,
    { dryRun }
  )
}

// 發送紀錄（發過幾次、發給誰、誰沒收到）
// params: configId / trigger / result / startDate / endDate / keyword / page / pageSize
export const getRevisitReminderLogs = (businessId, params = {}) => {
  return api.get(`/api/business_B/${businessId}/revisit-reminder-logs`, {
    params
  })
}

// 获取客户标签列表
export const getCustomerTags = (businessId) => {
  return api.get(
    `/api/business_B/${businessId}/revisit-reminder-configs/customer-tags`
  )
}

// 获取会员等级列表
export const getMembershipTiers = (businessId) => {
  return api.get(`/api/business_B/${businessId}/membership-tiers`)
}

// 获取服务列表（用于服务筛选）
export const getProducts = (businessId) => {
  return api.get(`/api/business_B/${businessId}/products`)
}
